import type { SupportApiError, SupportTicketStatus } from '../../services/api';

/** Contact admin (launch item A7): the Shop writes to the Vault Play admin team. */
export const CONTACT_ADMIN_PATH = '/contact-admin';
export const CONTACT_ADMIN_LABEL = 'Contact admin';

/** Fired after the Shop opens or reads a ticket, so the sidebar count refreshes at once. */
export const CONTACT_ADMIN_CHANGED_EVENT = 'contact-admin-changed';

/** Same limits as the backend (supportTicketConfig: PLAYER_MESSAGE_MAX, REPLY_MESSAGE_MAX). */
export const NEW_TICKET_MIN = 10;
export const NEW_TICKET_MAX = 1000;
export const REPLY_MAX = 2000;

export const STATUS_META: Record<SupportTicketStatus, { label: string; className: string }> = {
  pending: { label: 'Sent', className: 'bg-amber-50 text-amber-800 ring-amber-200' },
  in_progress: { label: 'In progress', className: 'bg-sky-50 text-sky-800 ring-sky-200' },
  resolved: { label: 'Resolved', className: 'bg-emerald-50 text-emerald-800 ring-emerald-200' },
  closed: { label: 'Closed', className: 'bg-stone-100 text-stone-700 ring-stone-200' },
};

export function ticketPath(ticketNumber: string): string {
  return `${CONTACT_ADMIN_PATH}/${encodeURIComponent(ticketNumber)}`;
}

/** The server's message and field errors from a failed request. */
export function apiError(error: unknown, fallback: string): { message: string; errors: Record<string, string> } {
  const data = (error as { response?: { data?: SupportApiError } })?.response?.data;
  return { message: data?.message && data.code !== 'VALIDATION_FAILED' ? data.message : fallback, errors: data?.errors ?? {} };
}

export function announceContactAdminChange(): void {
  window.dispatchEvent(new Event(CONTACT_ADMIN_CHANGED_EVENT));
}
